module.exports = __webpack_public_path__ + "static/media/teams-women-discussing-graphs-in-teamwork.a8972be8.png";